import React from 'react';

import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import ShoppingCartContainer from 'containers/shopping-cart';

const ShoppingCart = () => {
  return (
    <div>
      <HeaderContainer />
      <ShoppingCartContainer />
      <FooterContainer />
    </div>
  );
};

export default ShoppingCart;
